var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.183 5.79603C16.3325 5.79588 14.526 6.37088 13.0048 7.44425C11.4836 8.51762 10.3201 10.0383 9.66968 11.8031L11.7989 12.6167C12.3613 11.0952 13.4297 9.82279 14.8182 9.0211C16.2066 8.21941 17.8271 7.93922 19.3975 8.22932C20.9679 8.51942 22.3886 9.36143 23.4123 10.6087C24.436 11.856 24.9979 13.4296 25 15.0554C25 16.8973 24.2818 18.6636 23.0033 19.966C21.7249 21.2683 19.991 22 18.183 22H6.82131C5.21162 22.001 3.6535 21.4218 2.42284 20.3647C1.19219 19.3077 0.368404 17.8412 0.0973541 16.2248C-0.173696 14.6084 0.125477 12.9465 0.941898 11.5332C1.75832 10.12 3.03932 9.04664 4.55806 8.50325C4.46074 6.50393 5.09343 4.53869 6.33414 2.9864C7.57485 1.43411 9.33574 0.404681 11.2773 0.0965702C13.2189 -0.211541 15.2038 0.223482 16.8492 1.31777C18.4946 2.41207 19.6841 4.08815 20.1883 6.02289C19.5302 5.87195 18.8576 5.79586 18.183 5.79603Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/CloudUploadIcon.7f7ba96f9ed73ac1c3b4d4aa8153e4b4.svg";
export { ForwardRef as ReactComponent };